import { AuthLoadingProps } from './AuthLoading.types';
import './AuthLoading.css';

/**
 * AuthLoading Component
 *
 * Displays a loading overlay during authentication process.
 * Shows spinner and customizable message while verifying user access.
 *
 */
export const AuthLoading = ({ message = 'Перевірка доступу користувача...' }: AuthLoadingProps) => {
  return (
    <div className="auth-loading-overlay">
      <div className="auth-loading-content">
        <div className="spinner"></div>
        <p>{message}</p>
      </div>
    </div>
  );
};
